module.exports = __webpack_public_path__ + "static/media/Escape.c4a14bc1.png";